requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.data('xCookieBanner', (delay) => ({
      show: false,
      storageKey: 'eurus:cookie-notice:dismissed',
      init() {
        let dismissed = false;
        try {
          dismissed = localStorage.getItem(this.storageKey) === 'true';
        } catch (e) {
          dismissed = false;
        }
        if (dismissed) return;

        setTimeout(() => {
          requestAnimationFrame(() => {
            this.show = true;
          });
          document.dispatchEvent(new CustomEvent("eurus:customer-privacy:loaded"));
        }, delay * 1000);
      },
      dismiss() {
        try {
          localStorage.setItem(this.storageKey, 'true');
        } catch (e) {}
        requestAnimationFrame(() => {
          this.show = false;
        });
      },
      handleAccept() {
        try {
          if (window.Shopify && window.Shopify.customerPrivacy) {
            window.Shopify.customerPrivacy.setTrackingConsent(true, () => {});
          }
        } catch (e) {}
        this.dismiss();
      },
      handleDecline() {
        try {
          if (window.Shopify && window.Shopify.customerPrivacy) {
            window.Shopify.customerPrivacy.setTrackingConsent(false, () => {});
          }
        } catch (e) {}
        this.dismiss();
      }
    }));
  });
});